import { Navigate, Route, Routes } from "react-router-dom";

import { ProvedorDeAmbiente } from "./nucleo/ambiente/ProvedorDeAmbiente";
import { ProvedorDeSessao } from "./nucleo/autenticacao/ProvedorDeSessao";
import { RotaProtegida } from "./nucleo/autenticacao/RotaProtegida";
import { PaginaEntrar } from "./nucleo/autenticacao/PaginaEntrar";
import { PaginaSegundoFator } from "./nucleo/autenticacao/PaginaSegundoFator";
import { PaginaInicial } from "./nucleo/PaginaInicial";
import { ProvedorDeEmpresas } from "./nucleo/empresa/ProvedorDeEmpresas";
import { Estrutura } from "./nucleo/layout/Estrutura";
import { PaginaFornecedores } from "./setores/regulatorio/fornecedores/PaginaFornecedores";
import { PaginaLotes } from "./setores/producao/materias-primas/PaginaLotes";
import { PaginaLote } from "./setores/producao/materias-primas/PaginaLote";
import { LoteEmAbas } from "./setores/producao/materias-primas/LoteEmAbas";
import { PaginaRecipientes } from "./setores/producao/recipientes/PaginaRecipientes";

/**
 * As rotas do sistema.
 *
 * <p>Hoje são três. Quando o RBAC existir, as rotas de setor serão
 * **construídas a partir das permissões** que a API devolver — rota sem
 * permissão não é uma rota que redireciona, é uma rota que não foi
 * criada (ADR-0004 §6). Item novo que alguém esqueceu de proteger deixa
 * de ser possível.
 */
export function App() {
  return (
    <ProvedorDeAmbiente>
      <ProvedorDeSessao>
        <ProvedorDeEmpresas>
        <Routes>
          <Route path="/entrar" element={<PaginaEntrar />} />
          <Route path="/entrar/codigo" element={<PaginaSegundoFator />} />
          <Route
            path="/"
            element={
              <RotaProtegida>
                <PaginaInicial />
              </RotaProtegida>
            }
          />
          <Route
            path="/regulatorio/fornecedores"
            element={
              <RotaProtegida>
                <Estrutura><PaginaFornecedores /></Estrutura>
              </RotaProtegida>
            }
          />
          <Route
            path="/producao/materias-primas"
            element={
              <RotaProtegida>
                <Estrutura><PaginaLotes /></Estrutura>
              </RotaProtegida>
            }
          />
          {/* A ficha de UM lote — o destino do resolvedor `/r/<token>`
              (ADR-0006). Ela vem ANTES da rota de etiqueta por leitura, não
              por precedência: o roteador do React casa por especificidade, e
              `lote/:codigo` não colide com `:id/etiqueta`.

              É protegida como todas as outras, e a decisão está escrita em
              `PaginaLote`: o lote carrega dado comercial, e o código impresso
              é público de fato. Quem escaneia sem sessão cai no login e
              VOLTA para cá — ver `RotaProtegida`. */}
          <Route
            path="/producao/materias-primas/lote/:codigo"
            element={
              <RotaProtegida>
                <Estrutura><PaginaLote /></Estrutura>
              </RotaProtegida>
            }
          />
          {/* A ficha de UM VOLUME — o destino do QR impresso hoje. É a mesma
              tela: a pergunta de quem escaneou é a mesma ("o que é isto e
              posso usar?"), e o que muda é que aqui ela sabe QUAL dos vinte
              tambores está na mão. Duas telas divergiriam. */}
          <Route
            path="/producao/materias-primas/volume/:token"
            element={
              <RotaProtegida>
                <Estrutura><PaginaLote /></Estrutura>
              </RotaProtegida>
            }
          />
          {/* O parque de recipientes. Protegida como todas: a ficha do
              recipiente exige sessão (ADR-0012 item 2, regra 4), e o
              histórico dela mostra que material já esteve em cada tambor. */}
          <Route
            path="/producao/recipientes"
            element={
              <RotaProtegida>
                <Estrutura><PaginaRecipientes /></Estrutura>
              </RotaProtegida>
            }
          />
          {/* ── O LOTE, EM ABAS (#36) ────────────────────────────────────
              `resumo` · `volumes` · `etiqueta`, uma seção por endereço.

              🔴 `/:id/etiqueta` — o endereço que o PO usa e guardou — casa
              AQUI, porque `etiqueta` é o nome da aba. Não há redirecionamento
              a manter: a URL antiga é o endereço da aba de etiquetas.

              ⚠️ Ela vem DEPOIS de `lote/:codigo` e `volume/:token` por leitura,
              não por precedência: o roteador do React ordena por
              especificidade, e segmento estático (`lote`, `volume`) vence
              segmento dinâmico (`:id`). Um lote cujo identificador fosse
              literalmente "lote" continuaria abrindo a ficha do QR — e é o
              lado seguro, porque aquele é o endereço impresso.

              A rota sem aba existe para o endereço digitado pela metade:
              `LoteEmAbas` a REDIRECIONA para `/resumo` preservando
              `?empresa=`, em vez de deixá-la cair no painel — e em vez de
              mostrar o resumo num endereço que diz outra coisa. */}
          <Route
            path="/producao/materias-primas/:id/:aba"
            element={
              <RotaProtegida>
                <Estrutura><LoteEmAbas /></Estrutura>
              </RotaProtegida>
            }
          />
          <Route
            path="/producao/materias-primas/:id"
            element={
              <RotaProtegida>
                <Estrutura><LoteEmAbas /></Estrutura>
              </RotaProtegida>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ProvedorDeEmpresas>
      </ProvedorDeSessao>
    </ProvedorDeAmbiente>
  );
}
